import type { FunctionComponent } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import NarratorDialog from '../../components/organisms/NarratorDialog';
import { Next } from '../../components/molecules/Dialog';
import RoundButton from '../../components/atoms/RoundButton.Container';
import { IS_DEBUG } from '../../utils/debug';

export interface OwnProps {
	onClose: () => void;
	onDetails: () => void;
	onNext: () => void;
}

export interface DispatchProps {}

export interface StateProps {
	playerName: string;
}

type Props = StateProps & DispatchProps & OwnProps;

const IntroScreen: FunctionComponent<Props> = (props: Props) => {
	const { onDetails, onNext, onClose, playerName } = props;
	const { t } = useTranslation();

	return (
		<NarratorDialog
			onClose={IS_DEBUG ? onClose : undefined}
			text={t('introduction.main.description', {
				returnObjects: true,
				playerName
			})}
		>
			<RoundButton
				onClick={onDetails}
				width="32vmin"
				height="20vmin"
				position="absolute"
				right="34vmin"
				bottom="-1%"
			>
				<Trans>introduction.main.why</Trans>
			</RoundButton>
			<Next onClick={onNext}>
				<Trans>introduction.main.next</Trans>
			</Next>
		</NarratorDialog>
	);
};

export default IntroScreen;
